import { post } from '../Services/http';
import { catchError } from './Error.action';
import { QUICK_SEARCH_ERROR, QUICK_SEARCH_QUERY, QUICK_SEARCH_RECEIVE, QUICK_SEARCH_SELECT_ITEM, QUICK_SEARCH_SHOW_SEARCH_RESULT, } from '../constants';
let abortController;
export const query = (q) => (dispatch, getState) => {
    // abort any existing, pending request.
    // It's ok to call .abort() after the fetch has already completed, fetch simply ignores it.
    abortController && abortController.abort();
    abortController = new AbortController();
    const params = new URLSearchParams(window.location.search);
    const hideInternalParam = params.get('hide_internal') === '1' ? '?hide_internal=1' : '';
    return post('/api/quickSearch' + hideInternalParam, q, abortController)
        .then((response) => response.json())
        .then((result) => dispatch(receive(result)))
        .catch((ex) => dispatch(catchError(ex, (error) => searchError(error))));
};
export const setSearchQuery = (query) => ({
    type: QUICK_SEARCH_QUERY,
    payload: {
        query,
    },
});
export const searchError = (error) => ({
    type: QUICK_SEARCH_ERROR,
    payload: {
        error,
    },
});
export const receive = (result) => ({
    type: QUICK_SEARCH_RECEIVE,
    payload: {
        result: result.results,
        totalResults: result.totalResults,
        showResult: result.results && result.results.length > 0
    },
});
export const toggleShowSearchResult = () => (dispatch, getState) => {
    dispatch(show(!getState().quickSearch.showResult));
};
const show = (show) => ({
    type: QUICK_SEARCH_SHOW_SEARCH_RESULT,
    payload: {
        showResult: show,
    },
});
export const handleKeyDown = (event, opt) => (dispatch, getState) => {
    const { result, selectedItem } = getState().quickSearch;
    if (!result || !result.length) {
        return;
    }
    const max = result.length - 1, clip = (index) => (index < 0 ? max : index > max ? 0 : index);
    switch (event.keyCode) {
        case 38:
            dispatch(selectItem(clip(selectedItem - 1)));
            break;
        case 40:
            dispatch(selectItem(clip(selectedItem + 1)));
            break;
        case 13:
            const firstMatch = result[0];
            if (firstMatch && firstMatch.isExactMatch) {
                location.href = firstMatch.replacementProductUrl && !firstMatch.isAnonymousUser ? firstMatch.replacementProductUrl : firstMatch.url;
                break;
            }
            const selectedObject = result[selectedItem];
            const params = new URLSearchParams(window.location.search);
            const hideInternalActive = params.get('hide_internal') === '1';
            const baseSearchUrl = opt.searchUrl;
            const fullSearchUrl = hideInternalActive
                ? `${baseSearchUrl}${baseSearchUrl.includes('?') ? '&' : '?'}hide_internal=1`
                : baseSearchUrl;
            if (selectedObject && selectedObject.url) {
                location.href = selectedObject.url;
            }
            else {
                location.href = fullSearchUrl;
            }
            break;
        default:
            break;
    }
};
export const handleClickSearch = (opt) => (dispatch, getState) => {
    const { result } = getState().quickSearch;
    if (!result || !result.length) {
        return;
    }
    const firstMatch = result[0];
    if (firstMatch && firstMatch.isExactMatch) {
        location.href = firstMatch.replacementProductUrl && !firstMatch.isAnonymousUser ? firstMatch.replacementProductUrl : firstMatch.url;
        return;
    }
    const params = new URLSearchParams(window.location.search);
    const hideInternalActive = params.get('hide_internal') === '1';
    const baseSearchUrl = opt.searchUrl;
    const fullSearchUrl = hideInternalActive
        ? `${baseSearchUrl}${baseSearchUrl.includes('?') ? '&' : '?'}hide_internal=1`
        : baseSearchUrl;
    location.href = fullSearchUrl;
};
const selectItem = (selectedItem) => ({
    type: QUICK_SEARCH_SELECT_ITEM,
    payload: {
        selectedItem,
    },
});
